/**
 * A transition duration, or 0 for visitors who ask for reduced motion.
 *
 * Svelte transitions are Web Animations, so a `prefers-reduced-motion` media query
 * never reaches them — passing every duration through here is what does. At 0 the
 * element still mounts and unmounts on the same schedule; it simply arrives in place.
 *
 * Read per call, deliberately: toggling the OS setting then takes effect on the next
 * open rather than on the next reload, and a transition already in flight keeps the
 * duration it committed to.
 */
export function motionDuration(ms: number): number {
  // Guarded: SSR and jsdom-style environments have no matchMedia, where "no preference"
  // is the same answer a browser gives when the setting is unset.
  const reduce =
    typeof matchMedia === "function" && matchMedia("(prefers-reduced-motion: reduce)").matches;
  return reduce ? 0 : ms;
}
